export class LyLazySection extends HTMLElement {
    #observer = null
    #rendered = false

    connectedCallback() {
        if (this.#rendered) return

        if (!window.IntersectionObserver) {
            this._render()
            return
        }

        this.#observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return

            if (this.#rendered) return

            this._render()

            this.#rendered = true
            this.#observer?.disconnect()
            this.#observer = null
        }, {
            rootMargin: this.dataset.rootMargin || '400px 0px'
        })

        this.#observer.observe(this)
    }

    disconnectedCallback() {
        this.#observer?.disconnect()
    }

    _render = () => {
        const placeholder = this.querySelector('[data-placeholder]')
        const template = this.querySelector('template')
        if (placeholder && template) {
            placeholder.replaceWith(template.content.cloneNode(true))
            template.remove()
        }
    }
}
if (!customElements.get('ly-lazy-section')) {
    customElements.define('ly-lazy-section', LyLazySection)
}